import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';

import { HTTPService, HelperService, GeoLocationService } from 'app/services';
import { messages } from 'app/constants';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {
  user = { newPassword: '', confirmPassword: '' };
  validate: any = {};
  validationRules: { key: string; message: string; valid: boolean }[] = [];
  rememberMe: any;
  token: string = '';
  authId: any = {};
  disabled: boolean = false;
  navigation: any = {};
  state: any = null;

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private geoLocationService: GeoLocationService
  ) {
    // for using nav extras
    this.navigation = this.router.getCurrentNavigation();
    if (this.navigation.extras.state) {
      // destruct error message and set into view
      this.state = this.navigation.extras.state;
    }
  }

  ngOnInit(): void {
    this.validationRules = this.helperService.strongPassword(this.user);
    this.token = this.activatedRoute.snapshot.paramMap.get('token');
    this.authId = this.helperService.jwtDecode(this.token);
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  onFocus(name) {
    this.validate[name] = '';
  }

  onChange(name, value) {
    this.user[name] = value;
    this.validationRules = this.helperService.strongPassword(this.user);
  }

  backToSignIn() {
    this.router.navigate(['../login']);
  }

  validateForm() {
    let isValid = true;
    this.validate = {};

    // if (!this.user.newPassword) {
    //   this.validate.newPassword = messages.enterPassword;
    //   isValid = false;
    // }

    // if (!this.user.confirmPassword) {
    //   this.validate.confirmPassword = messages.enterConfirmPassword;
    //   isValid = false;
    // }

    // if (
    //   this.user.newPassword &&
    //   this.user.confirmPassword &&
    //   this.user.newPassword !== this.user.confirmPassword
    // ) {
    //   this.validate.confirmPassword = messages.passwordMismatch;
    //   isValid = false;
    // }

    if (!this.isFormValid()) {
      isValid = false;
    }

    return isValid;
  }

  // Method to check if all validation rules are satisfied
  isFormValid(): boolean {
    return this.validationRules.every((rule) => rule.valid);
  }

  onSubmit() {
    if (this.validateForm() && !this.disabled) {
      this.disabled = true;
      this.geoLocationService.getGeoInfo().then((geoInfo) => {
        const payload = {
          password: this.user.newPassword,
          geoInfo,
        };
        this.httpService.resetPassword(this.token, payload).then(
          (res) => {
            this.disabled = false;
            this.helperService.showToaster('success', 'Password changed successfully');
            const { userName } = res;
            const navigationExtras: NavigationExtras = {
              state: { userName },
            };
            this.router.navigate(['../login'], navigationExtras);
          },
          (error) => {
            this.validate.confirmPassword = error;
            this.disabled = false;
          }
        );
      });
    }
  }
}
